export const TRAFFIC_EVENT = 'e'
export const TRAFFIC_RESTORE = 'r'
